import React from "react";
import { Box, Text, Image } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import DrawingUploadImage from "@root/assets/images/drawing-upload-image-popover.png";

/**
 * Help content component for Drawing Upload
 * Displays instructions and example table for drawing file format
 */
export const DrawingUploadHelpContent: React.FC = () => {
  const { t } = useTranslation("common");

  return (
    <>
      {/* Heading */}
      <Text fontSize="18px" fontWeight="600" color="#15161A" mb={4}>
        {t("helpPopover.drawingUpload.heading")}
      </Text>

      {/* Description */}
      <Text
        fontSize="14px"
        color="#666666"
        mb={4}
        lineHeight="1.6"
        whiteSpace="pre-line"
      >
        {t("helpPopover.drawingUpload.description")}
      </Text>

      {/* Table Image */}
      <Box mt={4} overflowX="auto">
        <Image
          src={DrawingUploadImage}
          alt={t("helpPopover.drawingUpload.imageAlt")}
          maxW="100%"
          width="100%"
          height="auto"
          borderRadius="4px"
        />
      </Box>
    </>
  );
};
